"use client";
import React, { useState } from "react";
import explore from "@/../public/images/explore.svg";
import explore1 from "@/../public/images/explore1.svg";
import Image from "next/image";
import { PauseIcon, PlayIcon } from "@heroicons/react/20/solid";

const Hero = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayClick = () => {
    setIsPlaying(true);

    // Spend 3 seconds on Pause div, then return
    setTimeout(() => {
      setIsPlaying(isPlaying);
    }, 3000);
  };

  const handlePauseClick = () => {
    setIsPlaying(false);
  };

  return (
    <div className="w-full h-full">
      {isPlaying ? (
        <div className="relative w-full ease-in-out duration-300">
          <Image src={explore1} alt="hotel vicinity video" className="" />
          <div className="absolute top-2/5 left-1/2">
            <button
              onClick={handlePauseClick}
              className="bg-white/80 md:p-6 sm:p-4 p-2 rounded-full cursor-pointer"
            >
              <span className="flex items-center gap-2 bg-white rounded-full md:p-4 sm:p-2 p-1">
                <PauseIcon className="sm:w-5 sm:h-5 w-2 h-2 color-primary" />
              </span>
            </button>
          </div>
        </div>
      ) : (
        <div className="relative w-full ease-in-out duration-300">
          <Image src={explore} alt="hotel vicinity video" className="" />
          <div className="absolute top-2/5 left-1/2">
            <button
              onClick={handlePlayClick}
              className="bg-white/80 md:p-6 sm:p-4 p-2 rounded-full cursor-pointer"
            >
              <span className="flex items-center gap-2 bg-white rounded-full md:p-4 sm:p-2 p-1">
                <PlayIcon className="sm:w-5 sm:h-5 w-2 h-2 color-primary" />
              </span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Hero;
